import Vue from 'vue';
import availableAssets from '@/assets/rawData/faq/availableAssets.json';
import translation from '@/assets/rawData/i18n/multiAssetsFaqPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
export default Vue.extend({
    name: 'multiAssetsFaq',
    computed: {
        assets: () => availableAssets,
        questions() {
            return this.$t('multiAssetsFaqPage.questions');
        }
    },
    created() {
        applyPageI18NMessages(this, 'multiAssetsFaqPage', translation);
    }
});
